import { useRef, useState } from 'react';

import { AlertDialog, Icon, Text } from '@rbilabs/universal-components';
import { useRouter } from 'expo-router';
import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import QRCode from 'components/qrcode';
import { primitive } from 'styles/constants/primitives';
import { isMobile } from 'utils/environment';

const DOWNLOAD_APP_LINK = 'https://burgerking.app.link/t5PCWDQqkXb';

export const InstallAppButton = () => {
  const { formatMessage } = useIntl();
  const [isDownloadDialogOpen, setIsDownloadDialogOpen] = useState(false);
  const { navigate } = useRouter();

  const handleAppInstallPress = () => {
    if (isMobile()) {
      navigate(DOWNLOAD_APP_LINK);
    } else {
      setIsDownloadDialogOpen(true);
    }
  };

  return (
    <>
      <ActionButton size={ActionButtonSizes.SMALL} onPress={handleAppInstallPress}>
        {formatMessage({ id: 'installApp', defaultMessage: 'Install App' })}
      </ActionButton>
      <AlertDialog
        leastDestructiveRef={useRef(null)}
        isOpen={isDownloadDialogOpen}
        onClose={() => setIsDownloadDialogOpen(false)}
      >
        <AlertDialog.Content
          maxWidth={520}
          width="90%"
          style={{ padding: primitive.spacing.$2, gap: primitive.spacing.$3 }}
        >
          <AlertDialog.CloseButton />
          <AlertDialog.Header>
            <Text
              fontFamily="heading"
              style={{
                paddingVertical: primitive.spacing.$4,
                textAlign: 'center',
                color: primitive.$black,
                fontSize: primitive.fontSizes['2xl'],
              }}
            >
              {formatMessage({ id: 'getBkApp', defaultMessage: 'Get the Burger King App' })}
            </Text>
          </AlertDialog.Header>
          <AlertDialog.Body
            style={{
              gap: primitive.spacing.$4,
              paddingTop: primitive.spacing.$4,
              paddingBottom: primitive.spacing.$7,
              alignItems: 'center',
            }}
          >
            <Text style={{ fontSize: primitive.fontSizes.xs }}>
              {formatMessage({
                id: 'scanWithPhoneForRewards',
                defaultMessage: 'Scan with your phone and start earning rewards',
              })}
            </Text>
            <QRCode
              barcode={DOWNLOAD_APP_LINK}
              options={{
                color: {
                  light: primitive.$white,
                  dark: primitive.$black,
                },
              }}
              borderWidth="8"
              borderStyle="solid"
              borderColor={primitive.$black}
              padding={4}
              borderRadius={8}
            />
            <ActionButton
              leftIcon={<Icon name="mi:smartphone" />}
              variant={ActionButtonVariants.OUTLINE}
            >
              {formatMessage({
                id: 'scanMeNow',
                defaultMessage: 'Scan Me Now!',
              })}
            </ActionButton>
          </AlertDialog.Body>
        </AlertDialog.Content>
      </AlertDialog>
    </>
  );
};
